export const DM_PARTY_DEFAULTS_STORAGE_KEY = 'gridglory-dm-party-defaults';

export const DEFAULT_DM_PARTY_SIZE = 4;
export const DEFAULT_DM_PARTY_LEVEL = 1;

export function clampDmPartySize(n) {
  return Math.max(1, Math.min(10, Number(n) || DEFAULT_DM_PARTY_SIZE));
}

export function clampDmPartyLevel(n) {
  return Math.max(1, Math.min(20, Number(n) || DEFAULT_DM_PARTY_LEVEL));
}

export function normalizeDmPartyDefaults(raw) {
  if (!raw || typeof raw !== 'object') {
    return { partySize: DEFAULT_DM_PARTY_SIZE, partyLevel: DEFAULT_DM_PARTY_LEVEL };
  }
  return {
    partySize: clampDmPartySize(raw.partySize),
    partyLevel: clampDmPartyLevel(raw.partyLevel),
  };
}

export function loadDmPartyDefaults() {
  try {
    const stored = localStorage.getItem(DM_PARTY_DEFAULTS_STORAGE_KEY);
    if (!stored) {
      return { partySize: DEFAULT_DM_PARTY_SIZE, partyLevel: DEFAULT_DM_PARTY_LEVEL };
    }
    return normalizeDmPartyDefaults(JSON.parse(stored));
  } catch {
    return { partySize: DEFAULT_DM_PARTY_SIZE, partyLevel: DEFAULT_DM_PARTY_LEVEL };
  }
}

export function saveDmPartyDefaults(party) {
  const next = normalizeDmPartyDefaults(party);
  try {
    localStorage.setItem(DM_PARTY_DEFAULTS_STORAGE_KEY, JSON.stringify(next));
  } catch {
    // ignore quota / private mode
  }
  return next;
}
